import styled from "styled-components";

export const StyledPaymentScreen = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  padding: 30px 30px 30px 30px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  gap: 6px;
  position: relative;
  padding-bottom: 120px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 5% 30% 10% 30%;
  }
  .error-message {
    font-size: 12px;
    margin-top: 8px;
    color: #ef6469;
    width: 100%;
    font-weight: 600;
  }
  label {
    font-size: 14px;
    margin-bottom: 10px;
  }

  h2 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 24px;
    font-weight: 600;
    margin: 12px 0 4px 0;
  }

  h4 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 16px;
    margin: 0px;
    font-weight: 600;
  }
  p {
    font-size: 14px;
  }
  span {
    font-size: 14px;
  }
  .outlined-btn {
    border: 1px solid ${({ theme }) => theme.colors.primary};
    background-color: transparent;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 14px;
    font-weight: 600;
    margin: 24px 0;
  }
  .description {
    line-height: 22px;
    font-size: 14px;
    font-weight: 500;
  }
  .amenity-item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    .icon {
      font-size: 20px;
    }
    span {
      text-transform: capitalize;
      font-size: 14px;
    }
  }
  .tags-on-photo {
    display: flex;
    gap: 6px;
    position: absolute;
    z-index: 9;
    top: 360px;
    right: 20px;

    div {
      font-weight: 600;
    }
  }
  .go-back {
    cursor: pointer;

    z-index: 99;

    height: 20px;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.backgroundOpacity};
  }
`;

export const StyledForm = styled.form`
  .container-phone.react-tel-input {
    height: 44px;
    margin-top: 8px;

    input {
      height: inherit;
      width: inherit;
    }
    .country-list {
    }
    .search-box {
      width: 90% !important;
    }
  }
`;
export const StyledSummary = styled.div`
  box-sizing: border-box;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.skeletonPulse};
  border-radius: 12px;
`;

export const ButtonWrapperPositioner = styled.div`
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    left: 30%;
    right: 30%;
  }
`;
